<template>
    <div>
        <div v-if="$parent.phase === 'sustain'" class="matrix-filter">
            <div class="filter-sort">
                <div class="input-wrapper">
                    <input id="patients-all" v-model="params.program_length" value="" type="radio" name="patients" class="input-radio">
                    <label class="label-radio" for="patients-all">{{ __('All patients') }}</label>
                </div>

                <div class="input-wrapper">
                    <input id="patients-4-6" v-model="params.program_length" :value="[4,6]" type="radio" name="patients" class="input-radio">
                    <label class="label-radio" for="patients-4-6">{{ __('Patients') }} 4-6</label>
                </div>

                <div class="input-wrapper">
                    <input id="patients-7-12" v-model="params.program_length" :value="[7,12]" type="radio" name="patients" class="input-radio">
                    <label class="label-radio" for="patients-7-12">{{ __('Patients') }} 7-12</label>
                </div>
            </div>

            <SearchFilter v-model="params.search" />
        </div>

        <div class="matrix-filter">
            <div class="filter-sort">
                <span>{{ __('Sort by') }}:</span>

                <form id="sort-form" action="">
                    <button
                        v-for="order in allowedOrderOptions"
                        :key="order.name"
                        :class="{ active: order.name === params.order }"
                        type="button"
                        @click="orderBy(order)"
                    >
                        <span>{{ order.title }}</span>
                    </button>
                </form>
            </div>

            <SearchFilter v-if="$parent.phase !== 'sustain'" v-model="params.search" />
        </div>
    </div>
</template>

<script>
import SearchFilter from '@components/PatientsMatrix/Filters/SearchFilter'
export default {
    components: { SearchFilter },
    props: {
        filters: {
            type: Object,
            required: true
        },
        orderOptions: {
            type: Array,
            required: false,
            default() {
                return []
            }
        },
        intenseUnreadMessagesCount: {
            type: Number,
            required: false,
            default: 0
        },
        sustainUnreadMessagesCount: {
            type: Number,
            required: false,
            default: 0
        }
    },
    data() {
        return {
            availableOrderOptions: [
                { name: 'last_contact', title: this.__('Last contact') },
                { name: 'unread', title: this.__('Unread messages') },
                { name: 'prescription', title: this.__('Prescription') },
                { name: 'login', title: this.__('Login') },
                { name: 'newest', title: this.__('Latest') },
                { name: 'oldest', title: this.__('Oldest') }
            ],
            params: {
                search: this.filters.search || '',
                order: this.filters.order,
                program_length: this.filters.program_length || ''
            }
        }
    },
    computed: {
        allowedOrderOptions() {
            if (_.isEmpty(this.orderOptions)) {
                return this.availableOrderOptions
            }

            return this.availableOrderOptions.filter(sort => this.orderOptions.includes(sort.name))
        }
    },
    watch: {
        params: {
            handler: _.debounce(function() {
                this.$emit('change', this.params)
            }, 300),
            deep: true
        }
    },
    mounted() {
        if (!this.availableOrderOptions.some(e => e.name === this.params.order)) {
            this.params.order = _.first(this.allowedOrderOptions).name
        }
    },
    methods: {
        orderBy(order) {
            this.params.order = order.name
        }
    }
}
</script>
